<card>
    <div class="card-header-content">
        <h1>{{ Yii.t('wui-iqbh-js', 'Remarques') }}</h1>
        <!-- <div>
            <btn class="search-ctn-edit-large" [label]="showDetails ? 'Fermer' : 'Détails'" type="actionUndo" (click)="onShowDetails()"></btn>
            <btn class="search-ctn-edit-large" label="Réserver" type="actionUndo" (click)="book()"></btn>
        </div> -->
    </div>

    <div class="card-body-content card-marge-inside">
        <div class="list-row" *ngFor="let remark of remarks">
            {{ remark.text }}
        </div>
        <remark-form></remark-form>
    </div>
</card>
    